import { useEffect, useState } from "react";

const navItems = [
  { label: "作品简介", href: "#intro" },
  { label: "阅读入口", href: "#entries" },
  { label: "章节目录", href: "#chapters" },
  { label: "读者书评", href: "#reviews" },
  { label: "常见问题", href: "#faq" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/92 backdrop-blur-md border-b border-background-200/80"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="#top" className="flex items-end gap-3 cursor-pointer">
            <span className="font-heading text-xl md:text-2xl font-semibold tracking-wide text-foreground-950">
              迷人的保姆
            </span>
            <span className="hidden sm:flex flex-col leading-none pb-0.5">
              <span className="text-[10px] font-label tracking-[0.3em] text-primary-600">
                READING
              </span>
              <span className="mt-1 text-[10px] font-label tracking-[0.1em] text-foreground-500">
                全文阅读合集
              </span>
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="relative text-sm font-label text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-primary-500 after:transition-all after:duration-300 hover:after:w-full"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#chapters"
              className="hidden md:inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm font-label text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-book-read-line text-base" />
              开始阅读
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((prev) => !prev)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-700 cursor-pointer"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {open ? (
        <div className="md:hidden bg-background-50 border-t border-background-200/80">
          <nav className="flex flex-col px-4 py-3">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="py-3 text-sm font-label text-foreground-700 border-b border-background-100 last:border-0 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#chapters"
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-label text-background-50 cursor-pointer"
            >
              <i className="ri-book-read-line" />
              开始阅读
            </a>
          </nav>
        </div>
      ) : null}
    </header>
  );
}